export const defaultDateFormat = 'YYYY/MM/DD';
export const defaultDateTimeFormat = `YYYY/MM/DD HH:mm`;
